import React, { useState } from "react";
import { Styled } from './styled'
import WhatsappGreen from '~images/whatsapp_green.svg'
import { OnlinepbxModalContainer } from '@onpbx/onlinepbx-components'

export const WhatsappWidget: React.FC = () => {
    const [isModal, setIsModal] = useState(false);

    return (
        <>
            <Styled.Icon onClick={() => setIsModal(true)}>
                <WhatsappGreen />
            </Styled.Icon>
            {isModal &&
                <div className='onlinepbx__widget'>
                    <OnlinepbxModalContainer className='onlinepbx__lib__modal__container__content' onClick={() => setIsModal(false)}>
                        <Styled.Container>
                            <Styled.Content>
                                <Styled.Title>Отдел продаж на связи в WhatsApp</Styled.Title>
                                <Styled.Link href={'https://web.whatsapp.com/send?phone=%2B79122602328&text=Добрый день.'}>Написать с компьютера</Styled.Link>
                                <Styled.Text>или с телефона</Styled.Text>
                                <Styled.QR src={process.env.PUBLIC_DIR + '/images/qr-whatsapp.png'} alt='qr' />
                            </Styled.Content>
                        </Styled.Container>
                    </OnlinepbxModalContainer>
                </div>
            }
        </>
    )
}
